import useVaultData from '@modules/opportunities/entities/opportunity/query/useVaultData';
import { APPLICANT_TYPE } from '@modules/opportunities/entities/opportunity/const';
import { Skeleton } from '@mantine/core';
import { CaseCreationBankDocumentsRoute } from '@modules/opportunities/presentation/routes';
import { useEffect } from 'react';
import { trackAmplitudeEvent } from '@shared/analytics/amplitude';
import { USER_EVENTS } from '@shared/analytics/events';
import { Navigate } from '@tanstack/react-router';
import { BulkUploadWrapper } from './BulkUploadWrapper';

const CaseCreationDocuments = () => {
  const { opportunityId } = CaseCreationBankDocumentsRoute.useParams();
  const { applicant } = CaseCreationBankDocumentsRoute.useSearch();
  const { data, isLoading } = useVaultData(opportunityId);

  useEffect(() => {
    // Track view
    trackAmplitudeEvent(USER_EVENTS.CASE.CASE_BANK_DOCUMENT_SECTION_VIEWED, {
      addToContext: true,
      case_id: opportunityId,
    });
  }, [opportunityId]);

  if (applicant.length === 0) {
    return (
      <Navigate
        to={ CaseCreationBankDocumentsRoute.to }
        params={ { opportunityId } }
        search={ { applicant: 'main' } }
      />
    );
  }

  if (isLoading) {
    return (
      <Skeleton w='100%' height={ 500 } radius='8px' />
    );
  }
  const applicantData = data.applicants.find(
    (item) => {
      if (applicant !== 'main') {
        return item.applicant_type !== APPLICANT_TYPE.mainApplicant;
      }

      return item.applicant_type === APPLICANT_TYPE.mainApplicant;
    }
  );

  return (
    <BulkUploadWrapper
      key={ applicantData?.applicant_id! }
      applicantId={ applicantData?.applicant_id! }
      oppId={ opportunityId }
      documents={ applicantData?.required_documents! }
      applicantName={ `${applicantData?.first_name} ${applicantData?.last_name}` }
    />
  );
};

export default CaseCreationDocuments;
